module.exports = __webpack_public_path__ + "img/emp5-1.b8d2d5cb.jpg";